module.exports = __webpack_public_path__ + "img/information-and-communications-technology.740c388d.svg";